export type LogLevel = 'info' | 'debug' | 'warn' | 'error';

export const LOG_LEVELS: LogLevel[] = [
	'info',
	'debug',
	'warn',
	'error'
]

const useLogger = ({module = 'Wooptima'}) => {
	const logMessage = (type: LogLevel, message: string, ...data: any) => console[type](`[${module}] ${message}`, ...(data ?? undefined))
	
	return Object.fromEntries(
		LOG_LEVELS.map(type => [type, (message: string, ...data: any) => logMessage(type, message, data)])
	)
}

export default useLogger;